module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3001.006 -2559.417 17.634 17.842\"><path d=\"M17.528.083a.319.319,0,0,0-.36-.06l-17,5.892a.312.312,0,0,0-.18.33.3.3,0,0,0,.27.27L8.833,8.883l2.354,8.68a.335.335,0,0,0,.27.27H11.5a.307.307,0,0,0,.285-.195L17.588.458A.343.343,0,0,0,17.528.083ZM11.651,16.424,9.432,8.554a.355.355,0,0,0-.27-.27L1.382,6.065,16.643.983Z\" transform=\"translate(-3000.991 -2559.409)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./frontend/images/icons/journey-arrow.svg
// module id = 409
// module chunks = 0